import { sgg } from 'ml-savitzky-golay-generalized';
/**
 * Calculate the first derivative using Savitzky–Golay filter.
 * @param data
 */
export function firstDerivative(data, options = {}) {
    const { x, y } = data;
    return { data: { x, y: sgg(y, x, { ...options, derivative: 1 }) } };
}
//# sourceMappingURL=firstDerivative.js.map